/** Column selector ids must match tanstack column `id`s in routeGuideColumns.tsx */
export const ROUTE_GUIDE_COLUMN_OPTIONS: { id: string; label: string }[] = [
  { id: "zipCode", label: "ZIP" },
  { id: "state", label: "State" },
  { id: "terminal", label: "Terminal" },
  { id: "coverageStatus", label: "Coverage" },
  { id: "direct", label: "Service Type" },
  { id: "obm", label: "3PL origin" },
  { id: "ibm", label: "3PL destination" },
  { id: "extra1", label: "Routing code 1" },
  { id: "extra2", label: "Routing code 2" },
  { id: "serviceDays", label: "Service Days" },
  { id: "dateUpdated", label: "Updated" },
];

/** Bump instanceKey suffix in routeGuide.tsx if prefs shape changes. */
export const ROUTE_GUIDE_COLUMNS_HIDDEN_BY_DEFAULT: string[] = ["extra1", "extra2"];

export const ROUTE_GUIDE_COLUMN_PREFS_INSTANCE_KEY = "route-guide-profiles-v3";
